import {animate, inView} from "motion";

const desktopAnimation = () => {
    inView(".blogCard", (info) => {
        animate(
            info.target,
            {
                opacity: [0, 0.2, 0.8, 1],
                transform: ["translateX(-100px) ", "none"],
            },
            { duration: 0.5, delay: 0.1 }
        );
    });
};


const mobileAnimation = () => {
    inView(".mobile-animation", (info) => {
        animate(info.target, { opacity: 1 }, { duration: 0.5, delay: 0.2 });
    });
};


const blogDetailDesktopAnimation = () => {
    const blogCard = document.querySelectorAll(".markdown-body");

    inView(blogCard, () => {
        animate(
            blogCard,
            {
                opacity: [0, 0.2, 0.8, 1],
                transform: ["translateY(-100px) ", "none"],
            },
            { duration: 0.5, delay: 0.1 }
        )
    })
}

export default {
    desktopAnimation,
    mobileAnimation,
    blogDetailDesktopAnimation
};
